import { useEffect, Fragment } from 'react'
import { Text, Separator } from '@/ui'
import { JournalEntryTransactionRow } from './JournalEntryTransactionRow'
import { fetchUserFinancialAccounts } from '@/actions/admin/adminFinancialAccountActions'
import { fetchAdminTransactionCategoriesIfNeeded } from '@/features/reports/reports.slice'
import { JournalEntryTransaction, JournalEntry } from '../types'
import { useAppDispatch } from '@/utils/typeHelpers'
import { TypographyStyles } from '@/styles'

interface JournalEntryTransactionsProps {
  userId: number
  transactions: JournalEntryTransaction[]
  entriesWithoutTransactions: JournalEntry[]
  dateRange: [string, string]
}

export const JournalEntryTransactions = ({
  userId,
  transactions,
  entriesWithoutTransactions,
  dateRange,
}: JournalEntryTransactionsProps) => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(fetchUserFinancialAccounts(userId))
    dispatch(fetchAdminTransactionCategoriesIfNeeded())
  }, [dispatch, userId])

  if (transactions.length === 0 && entriesWithoutTransactions.length === 0) {
    return (
      <>
        <Text variant={TypographyStyles.BODY_SM}>
          {' '}
          No journal entries match these filters.{' '}
        </Text>
        <Separator />
      </>
    )
  }

  return (
    <div className="mt-4 flex flex-col gap-6">
      {transactions.length > 0 &&
        transactions.map((jeTransaction) => (
          <Fragment key={jeTransaction.id}>
            <JournalEntryTransactionRow
              userId={userId}
              transaction={jeTransaction}
              dateRange={dateRange}
            />
            <Separator />
          </Fragment>
        ))}

      {entriesWithoutTransactions.length > 0 && (
        <>
          <JournalEntryTransactionRow
            userId={userId}
            transaction={{
              journalEntries: entriesWithoutTransactions,
              type: 'without_transaction',
            }}
            dateRange={dateRange}
          />
          <Separator />
        </>
      )}
    </div>
  )
}
